var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report__chapter only-print"},[_c('b-row',[_c('b-col',[_c('h3',{staticClass:"report__chapter__title"},[_c('span',{class:_vm.title === _vm.$t('report.interview_questions') ? 'mdi mdi-account-group-outline' : 'mdi mdi-account-group'}),_c('span',[_vm._v(_vm._s(_vm.title))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }